import {handleError, httpClient, httpClient1, httpClient2} from './index';

export const _requestLogin = (username, password) => {
  return httpClient2.post(`/batch/user/signin`,
      {username, password}).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else if (res.data.state_code === -1) {
      return Promise.reject(new Error('-1'));
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getEateryList = params => {
  return httpClient
    .get(`eatery/list/`, {
      headers: {
        "api-key": params.apiKey
      }
    })
    .then(res => res.data)
    .catch(handleError);
};

export const _getCanteenList = ({ apiKey, eateryId }) => {
  return httpClient
    .post(
      `canteen/list`,
      {
        eatery_id: eateryId
      },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(res.data.error_msg);
      }
    });
};
export const _getMachineList = ({ canteen_id, apiKey }) => {
  return httpClient
    .post(
      `machine/list`,
      {
        canteen_id
      },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    })
    .catch(handleError);
};

export const _getAllCanteen = apiKey => {
  return httpClient
    .get(`canteen/all_list`, {
      headers: {
        "api-key": apiKey
      }
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _setLanCanteen = (canteen_id, network_type) => {
  return httpClient.post(`set_lan_canteen`, { canteen_id, network_type }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};

export const _machineUseInfo = () => {
  return httpClient1.get(`machine/use_info`).then(res => {
    console.log(res);
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
